export const PUBLIC_REPORT_HOST = 'https://bmwstation.fut-app.com';

export function publicQuoteUrl(token) {
  const base =
    process.env.REACT_APP_PUBLIC_REPORT_BASE_URL?.replace(/\/$/, '') ||
    PUBLIC_REPORT_HOST;
  return `${base}/q/${token}`;
}

export function whatsAppShareUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function quoteShareMessage(quote, url) {
  const vehicle = quote?.vehicle
    ? [quote.vehicle.brand, quote.vehicle.model, quote.vehicle.year, quote.vehicle.plate_number]
        .filter(Boolean)
        .join(' ')
    : [quote?.brand, quote?.model, quote?.year, quote?.plate_number]
        .filter(Boolean)
        .join(' ');
  const kind =
    quote?.quote_kind === 'inspection' ? 'Inspection quotation' : 'Service quotation';
  return [kind, vehicle || null, url].filter(Boolean).join('\n');
}

export function isQuoteShareActive(quote) {
  if (!quote?.share_token || quote.share_revoked_at) return false;
  if (!quote.share_expires_at) return true;
  return new Date(quote.share_expires_at).getTime() > Date.now();
}
